export enum LeagueStandingsViewMode {
    PUBLIC = 1,
    DRAFT  = 2
}